export default class BProfileDiaryGlucoseReportDay
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-profile-diary-glucose-report__day`;
	static checkboxSelector = () => `.b-profile-diary-glucose-report__day-checkbox`;

	check()
	{
		this.el.querySelector(BProfileDiaryGlucoseReportDay.checkboxSelector()).checked = true;
	}

	uncheck()
	{
		this.el.querySelector(BProfileDiaryGlucoseReportDay.checkboxSelector()).checked = false;
	}

	isCritical()
	{
		return this.el.querySelectorAll(`.profile-report-table__value--critical`).length ? true : false;
	}

	isChecked()
	{
		return this.el.querySelector(BProfileDiaryGlucoseReportDay.checkboxSelector()).checked;
	}
}
